export const STUDIO_PROD_URL = 'https://studio.atlassian.com';
export const STUDIO_STAGING_URL = 'https://studio.stg.atlassian.com';
